import { get, set} from 'idb-keyval';
import { state, ui, prefs, res, origPrefs } from './stores.js';
import { get as storeGet } from 'svelte/store';
import { getUID, addGame, uploadCampaign, setUsername } from './net.js';
import { allScoreableCards, scorePlayer } from './scores.js';
import { allCards, rebuildCardIndex } from './game.js';
import * as pako from 'pako';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { is_function } from 'svelte/internal';
import download from "downloadjs";
import * as jsonpatch from 'fast-json-patch';
import { cardsInPlay, updateMissions } from './card_actions.js';
import { analyseTurnLengths } from './turns.js';
import { perfMeasure, perfStart } from './perf.js';
import split from '../pb_hooks/stcc_split.js';

let saveGameTimer = null;
let saveGameInProgress = false;
let pendingImmediateSave = null;

export function makeUpload(state){
    
    let BvB = storeGet(res).BvB;

    let ret = {
        startDate: state.startDate,
        endDate: state.endDate || state.startDate,
        hostPlayer: state.hostPlayer || false,
        hostUsername: state.hostUsername,
        gameEndTrigger: state.gameEndTrigger || '',
        prefs: storeGet(prefs),
        practice: state.practice || false,
        setupRemoval: state.setupRemoval || false,
        players: state.players.map((p,i) => {
            return {
                bot: p.bot || false,
                botLevel: p.botLevel || false,
                dummy: p.dummy || false,
                captain: p.captain,
                score: p.score,
                stats: p.stats,
                scoreBreakdown: p.scoreBreakdown || '',
                dilithium: p.dilithium,
                latinum: p.latinum,
                glory: p.glory,
                whim: p.whim || 0,
                military: p.hasOwnProperty('military') ? p.military : '',
                research: p.hasOwnProperty('research') ? p.research : '',
                influence: p.hasOwnProperty('influence') ? p.influence : '',
                collective: p.hasOwnProperty('collective') ? p.collective : '',
                treachery: p.hasOwnProperty('treachery') ? p.treachery : '',
                username: p.username || '',
                cards: [...allScoreableCards(p).map(c => c.id)],
                cardCounts: {
                    deck: [...p.decks.deck, ...p.decks.discard, ...p.decks.hand].length,
                    log: p.decks.log ? p.decks.log.length : 0,
                    play: cardsInPlay(p, true).length
                }
            }
        }),
        cards: allCards().map(c => uploadableCard(c)),
        winners: state.winners || false,
        turns: state.turn,
        lengths: analyseTurnLengths(state)
        //fullStateUncompressed: JSON.stringify(state) //new TextDecoder().decode(pako.deflate(JSON.stringify(state))) // to get back: new TextEncoder.encode(pako.inflate(compressed))
    };

    if(!storeGet(res).BvB || storeGet(res).saveReplays){
        let json = JSON.stringify(state);
        let compressed = pako.deflate(json);

        let replayInfo = {
            initialState: storeGet(res).initialState,
            deltas: storeGet(res).deltas,
            hasDeltas: storeGet(res).deltas && storeGet(res).deltas.length > 0
            //undos: storeGet(res).undos
        }

        let replayCompressed = pako.deflate(JSON.stringify(replayInfo));

        ret = {
            ...ret,
            hasFullState: true,
            fullState: firebase.firestore.Blob.fromUint8Array(compressed),
            replayInfo: firebase.firestore.Blob.fromUint8Array(replayCompressed)
        }
    }
    if(state.gameType) ret.gameType = state.gameType;

    if(state.campaign){
        ret.campaign = true;
        ret.campaignInfo = state.campaignInfo;
        let g = ret.campaignInfo.games[ret.campaignInfo.games.length - 1];
        g.gameKey = `${state.startDate} ${state.hostPlayer}`;
        if(g.reward){
            if(g.reward.effect && Array.isArray(g.reward.effect)){
                g.reward.effect = g.reward.effect.flat(3);
            }
            ret.reward = g.reward;
        }
        set('campaign', ret.campaignInfo);
    }
   // console.log('ret before', ret)
    //console.log('sizes:', JSON.stringify(ret).length, compressed.length, replayCompressed.length)
    //console.log('extra size', JSON.stringify(ret.fullState).length, JSON.stringify(ret.replayInfo).length);
    //if(searchFor(ret, undefined, 'state', false)) console.log('undefined value in there', ret);
    //if(searchFor(ret, undefined, 'state', false)) console.log('still undefined! value in there', ret);
    //console.log('ret after', ret)
    return ret;
}

function str2ab(str) {
    var buf = new ArrayBuffer(str.length*2); // 2 bytes for each char
    var bufView = new Uint16Array(buf);
    for (var i=0, strLen=str.length; i<strLen; i++) {
      bufView[i] = str.charCodeAt(i);
    }
    return buf;
}

function ab2str(buffer){

    var bufView = new Uint16Array(buffer);
    var length = bufView.length;
    var result = '';
    var addition = Math.pow(2,16)-1;

    for(var i = 0;i<length;i+=addition){

        if(i + addition > length){
            addition = length - i;
        }
        result += String.fromCharCode.apply(null, bufView.subarray(i,i+addition));
    }

    return result;

}

export function decompress(p){
    try{
        // A Firestore Blob, the plain object one becomes after IndexedDB, or the raw bytes
        // PocketBase serves.
        let ab = split.blobBytes(p);
        let arr = pako.inflate(ab);
        let restored = JSON.parse(ab2str(arr));
        //console.log(restored, ab.length, arr.length, ab.length / arr.length);
        return restored;
    }catch(e){
        console.log(e);
        return false;
    }
}

function searchFor(o, thing, path, replace){
    if(o === thing){
        console.log(`Found at ${path}!`, o);
        return true;
    }else if(!o){
        return false;
    }else if(Array.isArray(o)){
        for(let i = 0; i < o.length; i++){
            if(searchFor(o[i], thing, `${path}[${i}]`)){
                o[i] = replace;
                console.log(`Replaced!`);
            }
        }
    }else if(typeof o == 'object'){
        for(let k of Object.keys(o)){
            if(searchFor(o[k], thing, `${path}.${k}`)){
                o[k] = replace;
                console.log(`Replaced!`)
            }
        }
    }
    return false;
}

function uploadableCard(c){
    let newC = {
        name: c.name,
        id: c.id,
        uniqueID: c.uniqueID,
    }

    if(c.stats) newC.stats = c.stats;
    if(c.entered) newC.entered = c.entered;
    if(c.left) newC.left = c.left;
    if(c.score || c.vp) newC.score = c.score || c.vp;
    if(c.chosenOptions) newC.chosenOptions = c.chosenOptions;
    if(c.suits.includes('mission')){
        if(c.complete){
            newC.complete = true;
        }else{
            newC.complete = false;
            newC.score = 0;
        }
    }
    
    //Object.assign({}, c); // TODO strip some bits?
    newC.info = storeGet(state).cardLog[c.uniqueID];
    if(newC.info.area == 'players'){
        newC.owner = storeGet(state).players[newC.info.player].captain;
    }
    //console.log(c, newC);
    return newC;
}

export async function saveInStack(){
    let soFar = await get('stacked_saves');
    if(!soFar) soFar = [];
    let upload = makeUpload(storeGet(state));
    upload.key = `${upload.startDate} ${upload.hostPlayer}`;
    soFar = soFar.filter(s => (s.key || `${s.startDate} ${s.hostPlayer}`) != upload.key);
    soFar.push(upload);
    try{
        await set('stacked_saves', soFar);
        ui.update(ui => {
            ui.saved = true;
            return ui;
        });
    }catch(e){
        console.log('Unable to save!', e);
        ui.update(ui => {
            ui.saved = false;
            return ui;
        })
    };   
}

export async function uploadQueuedGames(options = {}){
    let quiet = options.quiet || false;
    if(!window.navigator.onLine) return false;
    let stack = await get('stacked_saves');
    if(!stack || stack.length == 0) return false;

    let remaining = [];
    let uploadedAny = false;
    for(let s of stack){
        s.key = s.key || `${s.startDate} ${s.hostPlayer}`;
        if(await addGame(s, s.key, {quiet})){
            s.uploaded = gameURL(s);
            uploadedAny = true;
            if(s.key == `${storeGet(state).startDate} ${storeGet(state).hostPlayer}`){
                state.update(st => {
                    st.uploaded = s.uploaded;
                    console.log('game URL: '+st.uploaded)
                    return st;
                })
            }
        }else{
            remaining.push(s);
        }
    }
    await set('stacked_saves', remaining);
    return uploadedAny;
}

function getSave(){
   // console.log('state size', JSON.stringify(storeGet(state)).length);
   // console.log('res size', JSON.stringify(storeGet(state)).length);
   let r = storeGet(res);
   if(storeGet(prefs).noUndoSave) r = {...r, undos: [], prevStates: [], deltas: []}
    return {
        newFormat: true,
        state: storeGet(state),
        res: r,
        seats: storeGet(ui).seats,
        whenSaved: Date.now()
    };
}

export async function saveGame(name = 'default'){
    if(saveGameTimer){
        clearTimeout(saveGameTimer);
        saveGameTimer = null;
    }
    if(saveGameInProgress){
        pendingImmediateSave = name;
        return;
    }
    saveGameInProgress = true;
    const end = perfStart('save.saveGame', {name});
    //console.log('upload test', makeUpload(storeGet(state)))
    if(storeGet(res).BvB){
        end({name, skipped: 'BvB'});
        saveGameInProgress = false;
        return;
    }
    if(storeGet(state).players[storeGet(state).currentPlayer].bot){
        end({name, skipped: 'bot'});
        saveGameInProgress = false;
        return; // Don't let the bot save the game
    }
    let toSave = perfMeasure('save.getSave', () => getSave(), {name});
    try{
        const endIDB = perfStart('save.idbSet', {name});
        await set(name, toSave)
        endIDB({name});
        ui.update(ui => {
            ui.saved = true;
            return ui;
        });
    }catch(e){
        console.log('Unable to save!', e, storeGet(state));
        ui.update(ui => {
            ui.saved = false;
            return ui;
        })
    };
    end({name});
    saveGameInProgress = false;
    if(pendingImmediateSave){
        let pending = pendingImmediateSave;
        pendingImmediateSave = null;
        await saveGame(pending);
    }
    
}

export function saveGameSoon(name = 'default', delay = 500){
    if(saveGameTimer) clearTimeout(saveGameTimer);
    saveGameTimer = setTimeout(() => {
        saveGameTimer = null;
        saveGame(name);
    }, delay);
}

export function exportGame(){
    let toSave = getSave();
    let stringified = JSON.stringify(toSave); // More readable
    //download(stringified, 'game.json', 'application/json');
    download(new Blob([stringified]), 'game.json', 'application/json')
}

export function exportUpload(){
    let toUp = makeUpload(storeGet(state));
    let stringified = JSON.stringify(toUp);
    //download(stringified, 'upload.json', 'application/json');
    download(new Blob([stringified]), 'game.json', 'application/json')
}

export async function exportSave(name = 'default'){
    let newState = await get(name);
    if(!newState) return false;
    let stringified = JSON.stringify(newState, null, 2);
    /*if(stringified.includes('•')){
        console.log('includes •');
        stringified = stringified.replaceAll('•', '$$$BULLET$$$');
    }*/
    //download(stringified, 'game.json', 'application/json');
    download(new Blob([stringified]), 'game.json', 'application/json')
}


function normalizeLoadedStateSnapshot(u){
    if(!u || !Array.isArray(u.players)) return;
    if(!Array.isArray(u.log)) u.log = [];
    if(!u.choices){
        u.choices = {
            thisTurn: [],
            all: [],
            num: 1
        };
    }
    if(u.workingLog && !Array.isArray(u.workingLog)) u.workingLog = false;
    u.hostUsername = storeGet(prefs).username;
    for(let p of u.players){
        if(!p) continue;
        p.username = storeGet(prefs).username;
        if(!p.decks) continue;
        for(let d of Object.keys(p.decks)){
            if(!Array.isArray(p.decks[d])) continue;
            p.decks[d] = p.decks[d].filter(c => c && !Array.isArray(c));
        }
    }
}

export function disableSave(){
    ui.update(ui => {
        ui.canSave = false;
        ui.saved = false;
        return ui;
    })
}

export function savePrefs(prefs){
    //console.log(prefs, origPrefs);
    if(jsonpatch.compare(prefs, origPrefs).length == 0) return; // Not if identical
    set('prefs', prefs); 
}

export async function loadPrefs(){
    let pref = await get('prefs');
    if(!pref) return;
    if(!pref.username) delete pref.username;
    pref.stardates = true;
    pref.starterLocations = 4;
    pref.showHints = true;
    pref.shareGames = 'Never';
    //if(pref.stardateCards) delete pref.stardateCards;
    prefs.update(p => {
        p = {...p, ...pref};
        if(p.numActivations == Infinity) p.numActivations = -1;
        return p;
    })
}

export function enableSave(){
    ui.update(ui => {
        ui.canSave = true;
        return ui;
    })
    saveGame();
}

export function loadExported(file){
    try{
        //file = file.replaceAll(/(\d)\"\"/g, '$1•"'); // Fix previous issue with bad JSON export
        //file = file.replaceAll('6""', '6•"')
        let s = JSON.parse(file);
        if(!s) return false;
        load(s);
        return true;
    }catch(e){
        alert('Error reading JSON: '+e.message);
        return false;
    }
    
}

export async function loadGame(name = 'default'){
    let newState = await get(name);
    if(!newState) return false;
    load(newState);
    return true;
}

export async function loadReady(ready){
    load(ready);
}

function load(newState){
    
    if(newState.newFormat){
        let toUpdate = [newState.state];
        // Spreading an unbounded array into push blows the call stack once it is
        // big enough.
        if(newState.res.prevStates) for(let ps of newState.res.prevStates) toUpdate.push(ps);
        if(newState.res.initialState) toUpdate.push(newState.res.initialState);
        if(newState.res.savedState) toUpdate.push(newState.res.savedState);
        if(newState.res.interimState && newState.res.interimState.state) toUpdate.push(newState.res.interimState.state);
        if(newState.res.continuationCheckpoint && newState.res.continuationCheckpoint.state) toUpdate.push(newState.res.continuationCheckpoint.state);
        for(let u of toUpdate){
            normalizeLoadedStateSnapshot(u);
        }
        state.update(s => {
            s = newState.state;
            return s;
        })
        rebuildCardIndex(newState.state);
        
        res.update(r => {
            r = {
                modules: [],
                ...newState.res,
                botCharts: r.botCharts, // Just so parser error fixes are handled
                cards: r.cards,
                parsedCardText: r.parsedCardText,
                cachedTrawls: r.cachedTrawls, // derived from parsedCardText, so must come from the same place
                atCards: {...newState.res.atCards || {}, ...r.atCards}, // 
                atOps: {...newState.res.atOps || {}, ...r.atOps}
                // Do we also want to load cards and parsed card text?
            };
            if(!r.undos) r.undos = [];
            return r;
        })
        

    }else{
        for(let p of newState.players){
            for(let d of Object.keys(p.decks)){
                p.decks[d] = p.decks[d].filter(c => c && !Array.isArray(c));
            }
        }
        state.update(s => {   
            s =  newState;  
            return s;
        });
        rebuildCardIndex(newState);
    }

    updateMissions();
}

export let mainURL = `${window.location.protocol}//${window.location.host}${window.location.pathname}`; //'https://stcc-three.vercel.app';

export function gameURL(g){
    let p = new URLSearchParams();
    p.set('game', g.players.filter((p, i) => i == 0 || !g.practice).map(p => `${p.captain}${p.score}`).join('-'));
    let b = g.players.find(p => p.bot);
    if(b && b.botLevel){
        p.set('botLevel', b.botLevel)
    }
    p.set('turns', g.turns);
    p.set('key', g.key); 
    return `${mainURL}?${p.toString()}`;
}

export async function copyURL(url){
    await navigator.clipboard.writeText(url);
    alert('URL copied to clipboard!');
}


export async function uploadGame(){
    // First add game to local save, in case of upload errors
    if(!storeGet(state).hostUsername){
        await setUsername();
        state.update(s => {
            s.hostUsername = storeGet(prefs).username;
            return s;
        })
    }
    await saveInStack();
    let stack = await get('stacked_saves');
    if(storeGet(state).campaign){
        if(!storeGet(state).campaignInfo.username){
            state.update(s => {
                s.campaignInfo.username = storeGet(prefs).username;
                return s;
            })
        }
        if(!storeGet(state).campaignInfo.hasOwnProperty('ended')){
            state.update(s => {
                s.campaignInfo.ended = false;
                return s;
            })
        }
        try{
            await uploadCampaign(storeGet(state).campaignInfo);
        }catch(e){
            alert('Unable to upload campaign data: '+e.message)
        }
    }
    if(stack){
        return await uploadQueuedGames();
    }else{
        console.log('No saves to upload')
        return false;
    }
    
}
